import { Chip, ChipProps } from '@mui/material';
import { OrderStatus } from '../model/order.types';

interface IProps {
  statusType: OrderStatus['type'];
  size?: ChipProps['size'];
  variant?: ChipProps['variant'];
  sx?: ChipProps['sx'];
}

export function OrderStatusBadge({ statusType, size = 'small', variant, sx }: IProps) {
  const config = getStatusConfig(statusType);

  return (
    <Chip
      label={config.label}
      color={config.color === 'default' ? undefined : config.color}
      variant={variant ?? config.variant}
      size={size}
      sx={sx}
    />
  );
}

export function getStatusConfig(statusType: OrderStatus['type'] | string): {
  label: string;
  color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  variant: 'filled' | 'outlined';
} {
  const statusConfigMap: Record<
    string,
    {
      label: string;
      color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
      variant: 'filled' | 'outlined';
    }
  > = {
    Received: {
      label: '접수됨',
      color: 'primary',
      variant: 'filled',
    },
    Scheduling: {
      label: '일정 조율 중',
      color: 'primary',
      variant: 'filled',
    },
    VisitAppointed: {
      label: '방문 예약됨',
      color: 'default',
      variant: 'outlined',
    },
    VisitCompleted: {
      label: '방문 완료됨',
      color: 'success',
      variant: 'filled',
    },
    Requote: {
      label: '재견적',
      color: 'secondary',
      variant: 'outlined',
    },
    Unqualified: {
      label: '중복됨',
      color: 'secondary',
      variant: 'outlined',
    },
    ClosedLost: {
      label: '취소됨',
      color: 'error',
      variant: 'filled',
    },
  };

  return (
    statusConfigMap[statusType] || {
      label: statusType,
      color: 'default',
      variant: 'outlined',
    }
  );
}
